module.exports = __webpack_public_path__ + "img/light.62a71621.png";